import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Illuminate",
    description:
      "We map your ground truth — workflows, data, edges. No assumptions, only signal. The output is a system architecture you can defend.",
  },
  {
    num: "02",
    title: "Design",
    description:
      "We design the agents, models, and interfaces. Every decision is auditable. Every interface is shipped to a real human in week one.",
  },
  {
    num: "03",
    title: "Engineer",
    description:
      "Production-grade builds with full evaluation harnesses, observability, and rollback. We ship in iterations measured in days, not quarters.",
  },
  {
    num: "04",
    title: "Stride",
    description:
      "Launch, measure, expand. Like Buraq — one stride covers the horizon. We stay on as a partner until the system runs itself.",
  },
];

export default function Process() {
  return (
    <section id="process" className="section relative bg-[#FFFFFF]" data-testid="process-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-3">
            <div className="overline mb-6">[02] / Process</div>
          </div>
          <div className="lg:col-span-9">
            <h2 className="font-display text-4xl md:text-5xl lg:text-7xl leading-[0.95] tracking-tighter text-[#0A0A0A]">
              From dark, <span className="italic font-light">to dazzling</span>.
              <br />
              <span className="text-[#C99B1A]">In four strides.</span>
            </h2>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-0 border-t border-black/10">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`lg:col-span-3 p-8 lg:p-10 border-b lg:border-b-0 border-black/10 ${
                i < 3 ? "lg:border-r" : ""
              } group hover:bg-[#FBF8F0] transition-colors`}
              data-testid={`process-step-${step.num}`}
            >
              <div className="flex items-baseline gap-3 mb-8">
                <span className="font-display text-[#C99B1A] text-5xl lg:text-6xl font-light">{step.num}</span>
                <div className="h-px flex-1 bg-black/10 group-hover:bg-[#C99B1A]/50 transition-colors" />
              </div>
              <h3 className="font-display text-2xl lg:text-3xl tracking-tighter mb-4 text-[#0A0A0A]">{step.title}</h3>
              <p className="text-black/60 text-sm leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
